const state = {
    page: 1,
    perpage: 10,
    last_page: 0,
    tot_logs: 0,
    cron_log_id: 0,
    responsePayload: []
}

export default state